const Datareset = () => {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      minHeight: "100vh", background: "#f5f7fa",
      fontFamily: "system-ui, -apple-system, sans-serif",
    }}>
      <div style={{ textAlign: "center", padding: "40px 24px", maxWidth: "480px" }}>

        <div style={{
          fontSize: "7rem", fontWeight: 900, lineHeight: 1,
          color: "#f57c00", marginBottom: "8px", letterSpacing: "-4px",
        }}>
          ⟳
        </div>

        <div style={{
          width: "48px", height: "3px", borderRadius: "99px",
          background: "#f57c00", margin: "0 auto 24px",
        }} />

        <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "#212121", marginBottom: "10px" }}>
          Demo Data Reset in Progress
        </div>
        <div style={{ fontSize: "0.9rem", color: "#9e9e9e", lineHeight: 1.7, marginBottom: "32px" }}>
          The demo data is reset every 30 minutes. Please wait a few minutes, then try again.
          If this keeps happening, please contact support.
        </div>

        <a
          href="https://demo.freelancersplace.net/"
          style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            padding: "11px 28px", borderRadius: "10px", textDecoration: "none",
            background: "#f57c00", color: "#fff", fontWeight: 700, fontSize: "0.9rem",
          }}
        >
          Try again
        </a>

      </div>
    </div>
  );
};

export default Datareset;
